import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { EmptyListText } from "@sprout/client-components/dist/EmptyList";
import { ItemType } from "sprout-graphql";
const TopicPageViewsTabsEmptyList = (props)=>{
    const { variant , type  } = props;
    const typeToString = type === ItemType.Post ? "leaf" : "branch";
    return /*#__PURE__*/ _jsx(EmptyListText, {
        children: variant === "archive" ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("em", {
                    children: [
                        "Finished with a ",
                        typeToString
                    ]
                }),
                `, but you don't want to trash it? `,
                /*#__PURE__*/ _jsxs("em", {
                    children: [
                        "Archive a ",
                        typeToString,
                        " for future reference"
                    ]
                }),
                `. To archive a ${typeToString}, select a ${typeToString} and tap "Archive"`,
                "."
            ]
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("em", {
                    children: `Trash ${type === ItemType.Post ? "leaves" : "branches"} that you don't need anymore`
                }),
                ".",
                ` To trash a ${typeToString}, select a ${typeToString} and tap "Trash"`,
                "."
            ]
        })
    });
};
export default TopicPageViewsTabsEmptyList;
